import { useDispatch } from "react-redux";
import { useCallback, useEffect, useRef } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import {get, post, put} from "../../api";
import { makeApiRequest } from "../../store/apiActions";

export default function useApiRequest() {
  const abortController = useRef(new AbortController());
  const dispatch = useDispatch();

  useEffect(() => {
    const abortControllerRef = abortController.current;
    return () => abortControllerRef.abort();
  }, []);

  const wrappedGet = useCallback(
    (url: string) => {
      // @ts-ignore
      return dispatch(makeApiRequest(async () => await get(url, abortController.current.signal))).then(unwrapResult);
    },
    [dispatch]
  );

  const wrappedPost = useCallback(
    <T>(url: string, data?: T) => {
      // @ts-ignore
      return dispatch(makeApiRequest(async () => await post(url, data, abortController.current.signal))).then(
        unwrapResult
      );
    },
    [dispatch]
  );

  const wrappedPut = useCallback(
      <T>(url: string, data?: T) => {
        // @ts-ignore
        return dispatch(makeApiRequest(async () => await put(url, data, abortController.current.signal))).then(
            unwrapResult
        );
      },
      [dispatch]
  );

  return { get: wrappedGet, post: wrappedPost, put: wrappedPut };
};
